import React from "react";
import * as palette from "../palette";
import PropTypes from "prop-types";

export default function NewsletterInput({ onInsert }) {
  return (
    <div>
      <form
        onSubmit={event => {
          event.preventDefault();
          event.stopPropagation();

          onInsert({
            callText: event.target.elements.callText.value || "",
            buttonText: event.target.elements.buttonText.value || "",
          });
        }}
        css={{
          width: 300,
          padding: 8,
          display: "grid",
          gridRowGap: 8,
        }}
      >
        <div
          css={{
            display: "grid",
            alignItems: "center",
            gridTemplateColumns: "1fr",
            gridRowGap: 4,
          }}
        >
          <span>Call text</span>

          <input
            type="text"
            name="callText"
            defaultValue="Subscribe to get the latest updates every week 🚀"
            css={{
              margin: 0,
              padding: 8,
              border: `solid 1px ${palette.sealBlue}`,
              borderRadius: 2,
            }}
          />
        </div>

        <div
          css={{
            display: "grid",
            alignItems: "center",
            gridTemplateColumns: "1fr",
            gridRowGap: 4,
          }}
        >
          <span>Button text</span>

          <input
            type="text"
            name="buttonText"
            defaultValue="Subscribe"
            css={{
              margin: 0,
              padding: 8,
              border: `solid 1px ${palette.sealBlue}`,
              borderRadius: 2,
            }}
          />
        </div>

        <button
          type="submit"
          css={{
            margin: 0,
            padding: 8,
            border: "none",
            borderRadius: 4,
            cursor: "pointer",
          }}
        >
          Insert
        </button>
      </form>
    </div>
  );
}

NewsletterInput.propTypes = {
  onInsert: PropTypes.func.isRequired,
};
